import React, { useMemo } from 'react';
import OGBadge from './OGBadge';

interface OGWelcomePopupProps {
  onClose: () => void;
}

const OGWelcomePopup: React.FC<OGWelcomePopupProps> = ({ onClose }) => {
  // 10 sparkles fired radially outward from the badge, each with a random
  // angle/distance/delay so the burst reads as organic rather than a
  // mechanical, perfectly-even ring.
  const sparkles = useMemo(() => Array.from({ length: 10 }).map((_, i) => {
    const angle = (i / 10) * Math.PI * 2 + Math.random() * 0.4;
    const distance = 70 + Math.random() * 40;
    return {
      key: i,
      sx: `${Math.cos(angle) * distance}px`,
      sy: `${Math.sin(angle) * distance}px`,
      delay: `${0.25 + Math.random() * 0.25}s`,
    };
  }), []);

  return (
    <div
      className="fixed inset-0 z-[1400] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
      onClick={onClose}
    >
      <div
        className="balloon-pop-in relative w-full max-w-sm rounded-3xl border border-yellow-500/30 bg-gradient-to-b from-[#161616] to-black p-8 text-center shadow-[0_0_40px_rgba(234,179,8,0.25)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative mx-auto mb-5 flex h-20 w-20 items-center justify-center">
          {sparkles.map((s) => (
            <span
              key={s.key}
              className="og-sparkle absolute h-1.5 w-1.5 rounded-full bg-yellow-300"
              style={{ '--sx': s.sx, '--sy': s.sy, animationDelay: s.delay } as React.CSSProperties}
            />
          ))}
          <OGBadge large className="og-badge-flip-in" />
        </div>
        <h2 className="text-xl font-black text-white">Congratulations!</h2>
        <p className="mt-2 text-sm leading-relaxed text-gray-300">
          You are one of the first 50 users, wear this badge proudly!
        </p>
        <button
          type="button"
          onClick={onClose}
          className="mt-6 w-full rounded-xl bg-yellow-500 py-3 font-bold text-black transition-colors hover:bg-yellow-400"
        >
          Let's Ride
        </button>
      </div>
    </div>
  );
};

export default OGWelcomePopup;
